module.exports = __webpack_public_path__ + "media/background-sound.447fe173.mp3";